/**
 * Human claim / receipt code for an accepted play (aval).
 * Crockford-like alphabet (no I, O, 0, 1) formatted as XXXX-XXXX.
 */

const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

function fnv1a32(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/** Build an 8-character code from a stable play id (deterministic). */
export function playClaimCodeFromPlayId(playId: string): string {
  const id = String(playId ?? '').trim();
  if (!id) return formatPlayClaimCode('AAAAAAAA');
  const h1 = fnv1a32(id);
  const h2 = fnv1a32(`claim:${id}:${h1}`);
  let chars = '';
  let n = h1;
  let m = h2;
  for (let i = 0; i < 8; i += 1) {
    const mix = (n + m * (i + 1)) >>> 0;
    chars += ALPHABET[mix % ALPHABET.length];
    n = (n >>> 3) ^ m;
    m = Math.imul(m, 2654435761) >>> 0;
  }
  return formatPlayClaimCode(chars);
}

/** Insert hyphen: ABCD1234 → ABCD-1234 */
export function formatPlayClaimCode(raw: string): string {
  const compact = String(raw ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 8)
    .padEnd(8, 'A');
  return `${compact.slice(0, 4)}-${compact.slice(4)}`;
}

/** Normalize user input for lookup (strips spaces/hyphens). */
export function normalizePlayClaimCode(input: string): string {
  return formatPlayClaimCode(String(input ?? ''));
}
